import { extractProjectHealthSections, getArrayItems, parseReportJson } from './project-health-utils.js'

function cleanText(value) {
  return typeof value === 'string' && value.trim() ? value.trim() : ''
}

export function projectHealthAssistantContext(report) {
  if (!report) return null
  const sections = extractProjectHealthSections(report.reportJson)
  const parsed = parseReportJson(report.reportJson)
  return {
    type: report.userGithubRepositoryId ? 'user_github_repository' : 'repository',
    contextType: report.userGithubRepositoryId ? 'user_github_repository' : 'repository',
    repositoryId: report.repoId || '',
    userGithubRepositoryId: report.userGithubRepositoryId || '',
    reportId: report.id || '',
    fullName: report.repoFullName || '',
    repoUrl: report.repoUrl || (report.repoFullName ? `https://github.com/${report.repoFullName}` : ''),
    title: report.repoFullName || report.repoName || '',
    name: report.repoName || report.repoFullName || '',
    description: cleanText(report.description),
    lastAnalysisSummary: sections.summary || report.summary || parsed.summary || '',
    resumeHighlights: getArrayItems(sections.resumeAdvice).length > 0
      ? getArrayItems(sections.resumeAdvice)
      : getArrayItems(parsed.resumeValue?.resumeAngles),
    risks: getArrayItems(sections.risks).length > 0
      ? getArrayItems(sections.risks)
      : getArrayItems(parsed.risks),
  }
}

export function repositoryAssistantContext(repo) {
  if (!repo) return null
  return {
    type: 'repository',
    contextType: 'repository',
    repositoryId: repo.id || repo.repoId || '',
    userGithubRepositoryId: '',
    reportId: repo.reportId || '',
    fullName: repo.fullName || '',
    ownerLogin: repo.ownerLogin || repo.owner_login || '',
    repoUrl: repo.htmlUrl || repo.repoUrl || '',
    title: repo.fullName || repo.name || '',
    name: repo.name || repo.fullName || '',
    description: repo.description || '',
    lastAnalysisSummary: repo.summary || '',
    language: repo.language || '',
    stars: repo.stars,
    forks: repo.forks,
    openIssues: repo.openIssues,
  }
}

export function userGithubRepositoryAssistantContext(repo, extras = {}) {
  if (!repo) return null
  return {
    type: 'user_github_repository',
    contextType: 'user_github_repository',
    repositoryId: '',
    userGithubRepositoryId: repo.id || repo.userGithubRepositoryId || '',
    reportId: extras.reportId || repo.reportId || '',
    fullName: repo.fullName || '',
    repoUrl: repo.htmlUrl || repo.repoUrl || (repo.fullName ? `https://github.com/${repo.fullName}` : ''),
    title: repo.fullName || repo.name || '',
    name: repo.repo || repo.name || repo.fullName || '',
    description: repo.description || '',
    lastAnalysisSummary: extras.summary || repo.lastAnalysisSummary || '',
    language: repo.primaryLanguage || repo.language || '',
    stars: repo.stars,
    forks: repo.forks,
    openIssues: repo.openIssues,
  }
}
